import React from 'react';
import styles from "./styles.module.scss";
import MultiSelectCellComponentWithSearch from 'views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
import { getFormattedDate, getFormattedTime } from 'modules/studentRefund/common/services';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { openInNewTab } from 'modules/studentRefund/common/services';
import APopover from 'views/pages/manage/common/a-popover';
import { TableHeaderActions } from 'views/pages/manage/employeeManagement/userProfile/helper';
import { Tooltip } from "@mui/material";
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';

const extractVendorConfigInfo = (config = {}) => {
  const {
    id,
    vendorType,
    businessArea = [],
    year = [],
    rolesByLevel = {},
    updatedOn,
    updatedBy
  } = config;

  const getLabels = (level) =>
    (rolesByLevel[level] || []).map(r => r.label);

  return {
    id,
    vendorType,
    businessArea,
    year,
    LEVEL_1: new Set(getLabels(1)),
    LEVEL_2: new Set(getLabels(2)),
    LEVEL_3: new Set(getLabels(3)),
    LEVEL_4: new Set(getLabels(4)),
    updatedOn,
    updatedBy
  };
};


const ConfigSummaryCard = ({
  config,
  editConfigHandler,
  isUpdatePermission,
  loading
}) => {

  const {
    id,
    vendorType,
    businessArea,
    year,
    LEVEL_1,
    LEVEL_2,
    LEVEL_3,
    LEVEL_4,
    updatedOn,
    updatedBy
  } = extractVendorConfigInfo(config);


  const menuItems = [
    isUpdatePermission ? {
      text: "Edit",
      handleClick: () => {
        editConfigHandler(config)
      }
    } : [],
    {
      text: "Logs",
      handleClick: () => {
        openInNewTab(`vendorSetup/logs?configId=${encodeURIComponent(id)}&eventType=${encodeURIComponent('APPROVAL_CONFIG')}`)
      },
    },
  ];

  return (
    <div className={'d-flex flex-column justify-content-between ' + styles['config-summary-card']}>
      <div className={`d-flex flex-column ${styles['vendor-card-header']}`}>
        <div className={`d-flex justify-content-between`}>
          <div>{vendorType?.label}</div>
          {/* {isUpdatePermission && <span onClick={() => editConfigHandler(config)} className={`${styles['edit-icon']}`}><BsThreeDotsVertical width={20} height={20} /></span>} */}
          <APopover
            buttonComponent={(onClick, styles) => (
              <Tooltip title="More Actions">
                <AButton
                  className="tiny-semi-bold color-dark"
                  disabled={loading}
                  onClick={onClick}
                >
                  <BsThreeDotsVertical style={{}} />
                </AButton>
              </Tooltip>
            )}
            menuComponent={(closeForm) => (
              <TableHeaderActions
                handleClose={closeForm}
                menuItems={menuItems}
              />
            )}
            sx={{
              "& .MuiPaper-root": {
                border: `1px solid #E2E2E2`,
                boxShadow: "0px 3px 4px 0px #00000014 !important",
                borderRadius: "8px",
              },
            }}
          // transformOriginVertical="center"
          // transformOriginHorizontal="left"
          />
        </div>
        <div className={styles['vendor-number']}>Config {id}</div>
      </div>
      <hr className='w-100' />

      <div className='d-flex justify-content-between'>
        <div>
          <MultiSelectCellComponentWithSearch data={businessArea} title={"BU"} />
          <div className={styles['label']}>BU</div>
        </div>
        <div>
          <MultiSelectCellComponentWithSearch data={year} title={"Year"} />
          <div className={styles['label']}>Year</div>
        </div>
      </div>

      <div className='d-flex justify-content-between'>
        <div>
          <div className={styles['label']}>L1 ROLES</div>
          <MultiSelectCellComponentWithSearch data={[...LEVEL_1]} title={"L1 Roles"} />
        </div>
        <div>
          <div className={styles['label']}>L2 ROLES</div>
          <MultiSelectCellComponentWithSearch data={[...LEVEL_2]} title={"L2 Roles"} />
        </div>
      </div>

      <div className='d-flex justify-content-between'>
        <div>
          <div className={styles['label']}>L3 ROLES</div>
          <MultiSelectCellComponentWithSearch data={[...LEVEL_3]} title={"L3 Roles"} />
        </div>
        <div>
          <div className={styles['label']}>L4 ROLES</div>
          <MultiSelectCellComponentWithSearch data={[...LEVEL_4]} title={"L4 Roles"} />
        </div>
      </div>

      <div className={styles['label']}>Last updated by {updatedBy} on {getFormattedDate(updatedOn)} at {getFormattedTime(updatedOn)}</div>


    </div>
  );
}

export default ConfigSummaryCard;